<template>
  <div>
    <header id="header" :style="`background-color: ${library.color};`">
    <div class="container">
      <h2>{{ library.name }}</h2>
    </div>
  </header>
    <div class="main">
      <div class="container page">
        <a-page-header
    style="border: 1px solid rgb(235, 237, 240)"
    :title="`${document.documentTypeAlias } - ${ document.documentName }`"
    @back="onBack()"
  >
  <a-descriptions size="small" :column="1">
        <a-descriptions-item :label="$t('name')">{{ document.documentName }}</a-descriptions-item>
        <a-descriptions-item :label="$t('number')">{{ document.documentNumber }}</a-descriptions-item>
      </a-descriptions>
  </a-page-header>
        <template>
</template>

        <LmFileViewer :files="fileList" v-if="fileList.length"/>
      </div>
    </div>
  </div>
</template>

<script>
import commonsApi from '@/api/commons'
import LmFileViewer from '@/components/LmFileViewer'
export default {
  components: {
    LmFileViewer
  },
  data () {
    return {
      documentInPdf: {},
      document: {},
      library: {}
    }
  },
  computed: {
    pdfDocumentPath () {
      return this.documentInPdf?.src
    },
    showPdfDocument () {
      return Boolean(this.pdfDocumentPath)
    },
    fileList () {
      if (!this.showPdfDocument) return {}
      return [
        {
          ...this.documentInPdf,
          path: this.pdfDocumentPath,
          attachments: []
        }
      ]
    }
  },
  methods: {
    onBack () {
      this.$router.go(-1)
    }
  },
  async created () {
    try {
      const res = await commonsApi.axiosGetWrapper(`/documentlibrary/document-details/${this.$route.params.slug}/page/${this.$route.params.id}`)
      this.document = res.data.document[0]
      this.documentInPdf = res.data.documentInPdf
      this.library = res.data.library[0]
    } catch (error) {
      console.log('error:', error)
    }
  }
}
</script>

<style scoped>
.main{
  background: #f3f5f7;
  height: 100%;
  min-height: 100vh;
}
#header{
    background: white;
    padding: 20px 0;
    /* margin-bottom: 7px; */
    flex: none;
    position: relative;
    z-index: 10;
    background-size: cover;
    box-shadow: 0 1px 4px 0 rgb(0 0 0 / 20%);
    background-position: 50%;
}
.page{
  /* background: #fff; */
  padding: 20px;
  /* margin-top: 20px !important; */
  display: block;
}
tr:last-child td {
  padding-bottom: 0;
}
</style>
